import React from 'react';
import { Activity, BarChart3, FileDown, ShieldCheck, User } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { buildRoleWorkspaceNavItems } from '../config/roleWorkspaceConfig';
import RoleLayoutShell from './RoleLayoutShell';

const FinanceLayout = () => {
  const auth = useAuth();
  const navItems = buildRoleWorkspaceNavItems('finance_manager', auth).map((item) => ({
    ...item,
    Icon: item.to === '/profile' ? User : item.to.includes('reports') ? BarChart3 : item.to.includes('monitoring') ? ShieldCheck : item.to.includes('exports') ? FileDown : Activity,
    anyPermissions: item.permission,
  }));

  return <RoleLayoutShell title="EMS" subtitle="Finance Workspace" navItems={navItems} />;
};

export default FinanceLayout;
